import { getCurrentDate } from './apiSport';
const mqtt = require('mqtt');
const pako = require('pako');

const _qos = 0;

class MQTTService {
  constructor() {
    this.client = null;
    this.subscriptions = new Map(); // Save all callback from topic
    this.connecting = false;
    this._intervalCheck = null; // 🆕 Thêm biến để giữ interval ID
    this._visibilityHandler = null; // 🆕 Giữ reference event listener để remove sau này

    this.MQTT_BROKER_URL = `${process.env.REACT_APP_MQTT_PROTOCOL}://${
      process.env.REACT_APP_MQTT_HOST
    }${process.env.REACT_APP_MQTT_PORT ? `:${process.env.REACT_APP_MQTT_PORT}` : ''}${
      process.env.REACT_APP_MQTT_PATH
    }`;
    this.MQTT_OPTIONS = {
      clientId: `chatbox_${Math.random().toString(16).slice(3)}`,
      clean: true,
      connectTimeout: 4000,
      reconnectPeriod: 1000,
      keepalive: 60,
      username: process.env.REACT_APP_MQTT_USERNAME,
      password: process.env.REACT_APP_MQTT_PASSWORD,
    };

    // this.setupAutoReconnect();
  }

  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  setupAutoReconnect() {
    if (this.isInIframe()) {
      console.log(`${getCurrentDate()} [ChatBox] | Running in iframe, auto reconnect disabled`);
      return;
    }
    // 🆕 FIX: lưu listener để cleanup khi disconnect
    this._visibilityHandler = () => {
      if (!document.hidden && !this.client?.connected && !this.connecting) {
        console.log(`${getCurrentDate()} [ChatBox] | Tab active again, checking MQTT...`);
        this.connect().catch(err =>
          console.warn(`${getCurrentDate()} [ChatBox] | Reconnect on visibility failed:`, err),
        );
      }
    };
    document.addEventListener('visibilitychange', this._visibilityHandler);
    // 🆕 FIX: lưu interval ID để clear sau này
    this._intervalCheck = setInterval(() => {
      if (!this.client?.connected && !this.connecting) {
        console.log(
          `${getCurrentDate()} [ChatBox] | MQTT auto-check: disconnected → reconnecting...`,
        );
        this.connect().catch(err =>
          console.warn(`${getCurrentDate()} [ChatBox] | Auto-reconnect failed:`, err),
        );
      }
    }, 20000);
    /*
    // auto reconnect when tab is active
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        console.log(`${getCurrentDate()} [ChatBox] | Tab active again, checking MQTT...`);
        if (!this.client?.connected && !this.connecting) {
          this.connect().catch(err => {
            console.warn(`${getCurrentDate()} [ChatBox] | Reconnect on visibility failed:`, err);
          });
        }
      }
    });

    // check connection every 20s
    setInterval(() => {
      if (!this.client?.connected && !this.connecting) {
        console.log(
          `${getCurrentDate()} [ChatBox] | MQTT auto-check: disconnected → reconnecting...`,
        );
        this.connect().catch(err => {
          console.warn(`${getCurrentDate()} [ChatBox] | Auto-reconnect failed:`, err);
        });
      }
    }, 20000);
    */
  }

  renewClientId() {
    this.MQTT_OPTIONS.clientId = `chatbox_${Math.random().toString(16).slice(3)}`;
  }

  connect() {
    if (this.client?.connected) {
      console.log(`${getCurrentDate()} [ChatBox] | Already connected`);
      return Promise.resolve();
    }

    if (this.connecting) {
      return new Promise(resolve => {
        const checkConnection = setInterval(() => {
          if (this.client?.connected) {
            clearInterval(checkConnection);
            resolve();
          }
        }, 100);
      });
    }

    this.connecting = true;
    return new Promise((resolve, reject) => {
      this.renewClientId();
      //this.client = mqtt.connect(this.MQTT_BROKER_URL, this.MQTT_OPTIONS);
      // 🆕 FIX: dọn client cũ và listener trước khi tạo client mới
      if (this.client) {
        try {
          this.client.removeAllListeners();
          this.client.end(true);
        } catch (e) {
          console.warn('Error cleaning previous MQTT client', e);
        }
      }

      this.client = mqtt.connect(this.MQTT_BROKER_URL, this.MQTT_OPTIONS);
      this.client.on('connect', () => {
        console.log(`${getCurrentDate()} [ChatBox] | Connected to MQTT Broker`);
        this.connecting = false;

        // Resubscribe to all topics after reconnection
        this.subscriptions.forEach((_, topic) => {
          this.subscribeTopic(topic);
        });

        resolve();
      });

      this.client.on('message', (topic, message) => {
        try {
          const isMessageTopic = this.isMessageTopic(topic);
          const parsedMessage = isMessageTopic
            ? this.decompressMessageToBuffer(message)
            : this.decompressMessage(message);
          const callback = this.subscriptions.get(topic);
          if (callback && parsedMessage) {
            callback(topic, parsedMessage);
          }
        } catch (error) {
          console.error('Error processing message:', error);
        }
      });

      this.client.on('error', err => {
        console.error(`${getCurrentDate()} [ChatBox] | MQTT Error:`, err);
        this.connecting = false;
        reject(err);
      });

      this.client.on('close', () => {
        console.log(`${getCurrentDate()} [ChatBox] | Connection closed`);
      });

      this.client.on('offline', () => {
        console.log(`${getCurrentDate()} [ChatBox] | Connection offline`);
      });

      this.client.on('reconnect', () => {
        console.log(`${getCurrentDate()} [ChatBox] | Connection reconnecting`);
      });
    });
  }

  decompressMessage(compressedMessage) {
    try {
      return pako.inflate(compressedMessage, { to: 'string' });
    } catch (error) {
      console.warn(`${getCurrentDate()} [ChatBox] | Error decompressing message:`, error);
      return compressedMessage;
    }
  }

  decompressMessageToBuffer(compressedMessage) {
    try {
      return pako.inflate(compressedMessage);
    } catch (error) {
      console.warn(`${getCurrentDate()} [ChatBox] | Error decompressing message:`, error);
      return compressedMessage;
    }
  }

  subscribeTopic(topic) {
    if (!this.client?.connected) {
      console.warn(
        `${getCurrentDate()} [ChatBox] | Client not connected. Will subscribe when connected.`,
      );
      return;
    }

    this.client.subscribe(topic, { qos: _qos }, err => {
      if (err) {
        console.log(
          `${getCurrentDate()} [ChatBox] | Subscription error for ${topic}-${_qos}:`,
          err,
        );
      } else {
        console.log(`${getCurrentDate()} [ChatBox] | Subscribed ${topic}-${_qos}`);
      }
    });
  }

  unsubscribeTopic(topic) {
    if (this.client?.connected) {
      this.client.unsubscribe(topic);
      console.log(`${getCurrentDate()} [ChatBox] | Unsubscribed from topic: ${topic}`);
    }
    this.subscriptions.delete(topic);
  }

  publish(topic, message) {
    if (!this.client?.connected) {
      console.warn(`${getCurrentDate()} [ChatBox] | Client not connected. Cannot publish.`);
      return;
    }

    this.client.publish(topic, JSON.stringify(message), { qos: _qos }, err => {
      if (err) {
        console.error(`${getCurrentDate()} [ChatBox] | Publish error to topic ${topic}:`, err);
      }
    });
  }

  disconnect() {
    if (this.client) {
      this.client.end(true, () => {
        console.log(`${getCurrentDate()} [ChatBox] | Disconnected from MQTT Broker`);
      });
      this.subscriptions.clear();
      this.client = null;
    }

    // 🆕 FIX: cleanup event & interval
    if (this._intervalCheck) {
      clearInterval(this._intervalCheck);
      this._intervalCheck = null;
    }
    if (this._visibilityHandler) {
      document.removeEventListener('visibilitychange', this._visibilityHandler);
      this._visibilityHandler = null;
    }
  }

  isMessageTopic(topic) {
    return /^chat\/room\/[^\/]+\/message$/.test(topic);
  }
}

// Create a singleton instance
const mqttService = new MQTTService();

// Export functions that use the singleton
export const connectMqtt = async (onMessageCallback, topics) => {
  await mqttService.connect();

  if (Array.isArray(topics)) {
    /*
    topics.forEach(topic => {
      mqttService.subscriptions.set(topic, onMessageCallback);
      mqttService.subscribeTopic(topic);
    });
    */
    topics.forEach(topic => {
      // 🆕 FIX: gỡ callback cũ trước khi đăng ký mới
      if (mqttService.subscriptions.has(topic)) {
        mqttService.unsubscribeTopic(topic);
        mqttService.subscriptions.delete(topic);
      }
      mqttService.subscriptions.set(topic, onMessageCallback);
      mqttService.subscribeTopic(topic);
    });
  } else if (typeof topics === 'string') {
    mqttService.subscriptions.set(topics, onMessageCallback);
    mqttService.subscribeTopic(topics);
  } else {
    console.error(`${getCurrentDate()} [ChatBox] | Invalid topics provided.`, topics);
  }
};

// Utility to show last characters of a string
export const showLastNChars = (inputString, length = 5, dots = '...') => {
  return `${dots}${inputString.slice(-length)}`;
};

export const disconnectMqtt = () => {
  mqttService.disconnect();
};

export const publishMessage = (topic, message) => {
  mqttService.publish(topic, message);
};

export const decompressMessage = message => {
  return mqttService.decompressMessage(message);
};

export const decompressMessageToBuffer = message => {
  return mqttService.decompressMessageToBuffer(message);
};

export const reconstructMessage = valuesString => {
  const valuesArray = valuesString.split('|^');
  const getNextValue = () => valuesArray.shift();
  return {
    roomId: getNextValue(),
    message: getNextValue(),
    id: getNextValue(),
    message_type: getNextValue(),
    created_at: Number(getNextValue()),
    user: {
      socialAvatar: getNextValue(),
      avatar: getNextValue(),
      role: getNextValue(),
      id: getNextValue(),
      username: getNextValue(),
      fullname: getNextValue(),
      level: Number(getNextValue()),
      ip: getNextValue(),
    },
  };
};

export default mqttService;
